import React, { useRef, useState, useEffect, useMemo } from "react";
import { getGridPixel, getSelectFrame } from "@/utils/canvasUtil";
import trackStore from "@/stores/clipEditor/trackState";
import playerStore from "@/stores/clipEditor/player";
// import { usePlayerState } from "@/stores/playerState";
import "./TrackPlayPoint.less";
import { observer } from "mobx-react";

const offsetLine = {
  left: 10,
};

const TrackPlayPoint = () => {
  //   const playerStore = usePlayerState();
  const [isDragging, setIsDragging] = useState(false);

  // 计算 trackStyle
  const trackStyle = useMemo(() => {
    return {
      left: `${offsetLine.left}px`,
      transform: `translate(${getGridPixel(trackStore.trackScale, playerStore.playStartFrame)}px, 0px)`,
    };
  }, [trackStore.trackScale, playerStore.playStartFrame]);

  // 处理鼠标按下事件
  const onMouseDown = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    playerStore.isPause = true;
    setIsDragging(true);
  };

  // 处理鼠标移动事件
  const onMouseMove = (event: MouseEvent) => {
    if (isDragging) {
      const trackContainer = document.getElementById("track-container");
      if (trackContainer) {
        const rect = trackContainer.getBoundingClientRect();
        const frame = getSelectFrame(
          event.pageX - offsetLine.left - rect.left,
          trackStore.trackScale,
          30
        );

        const playFrame = frame - 1;
        const startFrame = Math.max(
          0,
          Math.min(playFrame, trackStore.getFrameCount())
        );

        playerStore.setPlayStartFrame(startFrame);
      }
    }
  };

  // 处理鼠标松开事件
  const onMouseUp = (event: MouseEvent) => {
    setIsDragging(false);
  };

  // 监听鼠标移动和松开事件
  useEffect(() => {
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [isDragging]);

  return (
    <div
      id="trackPlayPoint"
      style={{
        position: "absolute",
        zIndex: 30,
        width: "1px",
        top: "0",
        bottom: 0,
        background: trackStore.editorConfig?.pointer?.lineColor ?? "#ab50ff",
        ...trackStyle,
      }}
      onMouseDown={onMouseDown}
    >
      <span
        className="play-point cursor-move"
        style={{
          background:
            trackStore.editorConfig?.pointer?.pointerColor ?? "#ab50ff",
        }}
      />
    </div>
  );
};

export default observer(TrackPlayPoint);
